var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.664 6.4L8 9.6L16 4.8L8 0L0 4.8H8V6.4H2.664ZM0 6.4V12.8L1.6 11.024V7.36L0 6.4ZM8 16L4 13.6L2.4 12.64V7.84L8 11.2L13.6 7.84V12.64L8 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.676170b2fc5649b09bd7a3963f23a3eb.svg";
export { ForwardRef as ReactComponent };